import { render, staticRenderFns } from "./TaskAttachmentUpload.vue?vue&type=template&id=2c4189eb&scoped=true"
import script from "./TaskAttachmentUpload.vue?vue&type=script&lang=js"
export * from "./TaskAttachmentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4189eb",
  null
  
)

export default component.exports